import { render, staticRenderFns } from "./SplitStr.vue?vue&type=template&id=796e69db&lang=pug&"
import script from "./SplitStr.vue?vue&type=script&lang=js&"
export * from "./SplitStr.vue?vue&type=script&lang=js&"
import style0 from "./SplitStr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports